import { ACTIVITY_TYPES } from "Constants/constants";
import { loadActivitySuccess } from "Reducers/activity/thunks/loadActivitySuccess.thunk";
import { startAppListening } from "Store/listenerMiddleware";

import { taskActivityReceived } from "./environmentTasks.reducer";
import { getEnvironmentTasksKey } from "./utils";

import type { AppStartListening } from "Store/listenerMiddleware";

/**
 * Bridges the live activity stream into the environmentTasks slice so the Task
 * containers card reflects state transitions without a page reload.
 *
 * The project's EventSource subscription already pushes every activity through
 * `loadActivitySuccess`; the card just doesn't consume them. This listener
 * forwards the `environment.task` ones to `taskActivityReceived`, keyed by
 * `project/env` — the same key the card builds via `getEnvironmentTasksKey`.
 * Org is intentionally left out of the key: the stream resolves it from
 * `orgByProjectId`, which can differ from the card's route org param, and a
 * mismatch there would drop every live update. The reducer ignores keys it
 * holds no entry for, so only loaded environments are touched and we never
 * spawn ghost entries from stream events.
 */
export const registerEnvironmentTasksListeners = (
  startListening: AppStartListening
) => {
  startListening({
    actionCreator: loadActivitySuccess.fulfilled,
    effect: (action, { dispatch }) => {
      for (const entry of action.payload) {
        const { activity } = entry;
        if (activity.type !== ACTIVITY_TYPES.ENVIRONMENT.TASK) continue;

        const key = getEnvironmentTasksKey({
          organizationId: entry.organizationDescriptionId,
          projectId: entry.projectDescriptionId,
          environmentId: entry.environmentDescriptionId
        });
        dispatch(taskActivityReceived({ key, activity }));
      }
    }
  });
};

// Register against the production middleware singleton.
registerEnvironmentTasksListeners(startAppListening);
